var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuIconVendorInactive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 11.5C17.66 11.5 18.99 10.16 18.99 8.5C18.99 6.84 17.66 5.5 16 5.5C14.34 5.5 13 6.84 13 8.5C13 10.16 14.34 11.5 16 11.5ZM8 11.5C9.66 11.5 10.99 10.16 10.99 8.5C10.99 6.84 9.66 5.5 8 5.5C6.34 5.5 5 6.84 5 8.5C5 10.16 6.34 11.5 8 11.5ZM8 13.5C5.67 13.5 1 14.67 1 17V19.5H15V17C15 14.67 10.33 13.5 8 13.5ZM16 13.5C15.71 13.5 15.38 13.52 15.03 13.55C16.19 14.39 17 15.52 17 17V19.5H23V17C23 14.67 18.33 13.5 16 13.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIconVendorInactive);
export default __webpack_public_path__ + "static/media/menu_icon_vendor_inactive.a637e09b092eb19a195003d1ec6b2e46.svg";
export { ForwardRef as ReactComponent };